import lookupService from 'nallian-shared-ui/lib/hoc/lookupService';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import apiRoutes from '../../../app/api/routes';

export default ComposedComponent =>
  lookupService({
    resource: 'myCommunity',
    url: addParametersToUri(apiRoutes.communityHost(), { url: document.location.hostname }),
  })(ComposedComponent);
